import { AccessPointProcessingGroup, ImportStepsResponse, License, LicenseTypeResponse } from "../models";

export type ImportAddStepsActions =
  { type: ImportAddStepsAction.AddGroups, groups: AccessPointProcessingGroup[] } |
  { type: ImportAddStepsAction.AddGroupsFailure, error: string } |
  { type: ImportAddStepsAction.AddStepsPanelDisplay, display: boolean } |
  { type: ImportAddStepsAction.ClearSelected } |
  { type: ImportAddStepsAction.GroupSelected, group: AccessPointProcessingGroup } |
  { type: ImportAddStepsAction.LicenseFilterChanged, license: License } |
  { type: ImportAddStepsAction.LoadAvailableSteps } |
  { type: ImportAddStepsAction.LoadAvailableStepsSuccess, result: ImportStepsResponse } |
  { type: ImportAddStepsAction.LoadAvailableStepsFailure, error: string } |
  { type: ImportAddStepsAction.LoadLicenseTypes } |
  { type: ImportAddStepsAction.LoadLicenseTypesSuccess, result: LicenseTypeResponse[] } |
  { type: ImportAddStepsAction.LoadLicenseTypesFailure, error: string };

export enum ImportAddStepsAction {
  AddGroups = "ADD_GROUPS",
  AddGroupsFailure = "ADD_GROUPS_FAILURE",
  AddStepsPanelDisplay = "ADD_STEPS_PANEL_DISPLAY",
  ClearSelected = "CLEAR_SELECTED",
  GroupSelected = "GROUP_SELECTED",
  LicenseFilterChanged = "LICENSE_FILTER_CHANGED",
  LoadAvailableSteps = "LOAD_AVAILABLE_STEPS",
  LoadAvailableStepsSuccess = "LOAD_AVAILABLE_STEPS_SUCCESS",
  LoadAvailableStepsFailure = "LOAD_AVAILABLE_STEPS_FAILURE",
  LoadLicenseTypes = "LOAD_LICENSE_TYPES",
  LoadLicenseTypesSuccess = "LOAD_LICENSE_TYPES_SUCCESS",
  LoadLicenseTypesFailure = "LOAD_LICENSE_TYPES_FAILURE",
}
